module.exports = __webpack_public_path__ + "img/pexels-martin-damboldt-799091.d2468248.jpg";